<app-timeline-transport-add-row-modal [orderTypeId]='this.orderTypeId' [date]='this.date'></app-timeline-transport-add-row-modal>
<app-timeline-transport-accepted-orders></app-timeline-transport-accepted-orders>
<app-timeline-transport-chat></app-timeline-transport-chat>
<!-- <app-timeline-artic-contract-orders *ngIf='this.orderTypeId === 4'></app-timeline-artic-contract-orders> -->
<div class='fullcontainer'>
  <app-timeline-transport-toolbar></app-timeline-transport-toolbar>

  <div class='timelineLineContainer'>
    <div class='timelineMainContainer'>
      <!-- <ng-container *ngIf='this.orderTypeId === 3'>
        <app-timeline-transport-main></app-timeline-transport-main>
      </ng-container>
      <ng-container *ngIf='this.orderTypeId === 5'>
        <app-timeline-transport-main></app-timeline-transport-main>
      </ng-container>
      <ng-container *ngIf='this.orderTypeId === 6'>
        <app-timeline-transport-main></app-timeline-transport-main>
      </ng-container>
      <ng-container *ngIf='this.orderTypeId === 7'>
        <app-timeline-transport-main></app-timeline-transport-main>
      </ng-container>
      <ng-container *ngIf='this.orderTypeId === 8'> -->
        <app-timeline-transport-main></app-timeline-transport-main>
        <!-- <app-timeline-transport-main-vertical *ngIf='!this.timelineSettings.timelineOrientationShredder'></app-timeline-transport-main-vertical> -->
      <!-- </ng-container> -->
    </div>
  </div>
</div>
